module.exports = __webpack_public_path__ + "static/media/ws_prev.a9e6213d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/img/current/ws_prev.png
// module id = 101
// module chunks = 0